var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowerScreens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "37.07,45.88 37.07,3.76 13.36,3.76 13.36,45.88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.07,46.38c-0.27,0-0.5-0.22-0.5-0.5V4.26H13.86v41.62c0,0.27-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5V3.76 c0-0.27,0.22-0.5,0.5-0.5h23.7c0.27,0,0.5,0.22,0.5,0.5v42.12C37.56,46.16,37.34,46.38,37.07,46.38z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 43.18,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 43.18,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 43.18,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.53,
    y: 43.18,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 43.18,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 40.85,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 40.85,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 38.53,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 36.2,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 36.2,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.61,
    y: 43.18,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.61,
    y: 38.53,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 33.88,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 31.55,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 31.55,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 29.23,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 26.9,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 26.9,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.61,
    y: 33.88,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.61,
    y: 29.23,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 24.58,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.61,
    y: 24.58,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.87,
    y: 40.85,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40.85,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 38.53,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.87,
    y: 36.2,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36.2,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.87,
    y: 43.18,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.87,
    y: 38.53,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 33.88,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.87,
    y: 31.55,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 31.55,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 29.23,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.87,
    y: 26.9,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26.9,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.87,
    y: 33.88,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.87,
    y: 29.23,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24.58,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.87,
    y: 24.58,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.13,
    y: 40.85,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 40.85,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 38.53,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.13,
    y: 36.2,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 36.2,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.14,
    y: 43.18,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.14,
    y: 38.53,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 33.88,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.13,
    y: 31.55,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 31.55,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 29.23,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.13,
    y: 26.9,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 26.9,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.14,
    y: 33.88,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.14,
    y: 29.23,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 24.58,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.14,
    y: 24.58,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 40.85,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.53,
    y: 40.85,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.53,
    y: 38.53,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 36.2,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.53,
    y: 36.2,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 43.18,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 38.53,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.53,
    y: 33.88,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 31.55,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.53,
    y: 31.55,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.53,
    y: 29.23,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 26.9,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.53,
    y: 26.9,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 33.88,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 29.23,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.53,
    y: 24.58,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 24.58,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.67,
    y: 40.85,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 40.85,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 38.53,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.67,
    y: 36.2,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 36.2,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.67,
    y: 43.18,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.67,
    y: 38.53,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 33.88,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.67,
    y: 31.55,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 31.55,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 29.23,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.67,
    y: 26.9,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 26.9,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.67,
    y: 33.88,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.67,
    y: 29.23,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 24.58,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.67,
    y: 24.58,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 40.85,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 36.2,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 43.18,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 38.53,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 31.55,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 26.9,
    className: "st1",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 33.88,
    className: "st0",
    width: 2.13,
    height: 2.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 29.23,
    className: "st0",
    width: 2.13,
    height: 2.32
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 24.58,
    className: "st0",
    width: 2.13,
    height: 2.32
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.51,
    y: 19.33,
    className: "st1",
    width: 23.46,
    height: 3.95
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "0.5,45.88 0.5,3.76 13.36,3.76 13.36,45.88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.36,46.38c-0.27,0-0.5-0.22-0.5-0.5V4.26H0.99v41.62c0,0.27-0.22,0.5-0.5,0.5S0,46.16,0,45.88V3.76 c0-0.27,0.22-0.5,0.5-0.5h12.87c0.27,0,0.5,0.22,0.5,0.5v42.12C13.86,46.16,13.64,46.38,13.36,46.38z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.71,
    y: 3.76,
    className: "st1",
    width: 12.44,
    height: 2.36
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.72,11.22l-5.71-0.01c0-0.91,0.74-1.01,1.65-1.01l2.41,0.01C26.98,10.21,27.72,10.3,27.72,11.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.78,12.39l-11.85-0.01c0-0.64,0.64-1.17,1.44-1.17h1.03l6.91,0.01h1.03 C30.14,11.22,30.78,11.74,30.78,12.39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.33,9.74v0.48L23.4,10.2V9.73c0-0.59,0.48-0.71,1.07-0.71l0.81,0C25.86,9.02,26.33,9.15,26.33,9.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.23,6.12H26.6c-1.17,0-2.13,0.95-2.13,2.13v0.87l0.76-0.02V8.08c0-0.66,0.53-1.19,1.19-1.19h10.79V6.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "37.07,45.88 37.07,3.76 49.5,3.76 49.5,45.88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,46.38c-0.27,0-0.5-0.22-0.5-0.5V4.26H37.56v41.62c0,0.27-0.22,0.5-0.5,0.5c-0.27,0-0.5-0.22-0.5-0.5 V3.76c0-0.27,0.22-0.5,0.5-0.5H49.5c0.27,0,0.5,0.22,0.5,0.5v42.12C50,46.16,49.78,46.38,49.5,46.38z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.07,
    y: 3.76,
    className: "st1",
    width: 12.44,
    height: 2.36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.76,32.66c0.14,0.6,0.54,1.11,1.1,1.38l0.75,0.37l0.16,0.08c0.01,0.01,0.04,0.01,0.05,0.02 c0.06,0.01,0.12,0.03,0.18,0.04c0.48,0.09,1.05,0.11,1.3-0.2l0.74-0.51c0.42-0.32,0.64-0.85,0.57-1.4 c-0.35-2.85-0.84-9.04,0.2-10.44c0,0-3.43,0.09-4.24,0.26c-0.47,0.09-0.6,0.66-0.6,0.66C39.55,26.34,40.3,30.74,40.76,32.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.55,35.12c-0.2,0-0.41-0.02-0.64-0.07L42.69,35c-0.03-0.01-0.07-0.02-0.1-0.04 c-0.01,0-0.03-0.01-0.04-0.01l-0.92-0.46c-0.69-0.34-1.19-0.97-1.36-1.71l0,0c-0.43-1.82-1.26-6.44,0.24-10.02 c0.05-0.25,0.34-0.84,0.96-0.96c0.83-0.17,3.97-0.26,4.33-0.27c0.19-0.01,0.37,0.1,0.45,0.27c0.09,0.17,0.07,0.37-0.04,0.52 c-0.76,1.02-0.62,5.96-0.11,10.09c0.08,0.71-0.21,1.42-0.76,1.85l-0.72,0.49C44.39,34.99,44.02,35.12,43.55,35.12z M42.98,34.05 l0.08,0.02c0.56,0.11,0.82,0.03,0.86-0.02c0.03-0.03,0.06-0.07,0.1-0.09l0.74-0.51c0.25-0.2,0.4-0.56,0.36-0.93 c-0.1-0.81-0.87-7.27-0.07-9.98c-1.16,0.04-2.88,0.12-3.37,0.23c-0.12,0.02-0.2,0.23-0.22,0.3c-1.42,3.39-0.62,7.76-0.22,9.49 l0,0c0.11,0.46,0.41,0.84,0.84,1.05L42.98,34.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000070809908231161945770000002111943408088214943_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.35,23.48c1.21-0.71,2.02-2.02,2.02-3.53c0-2.25-1.83-4.08-4.08-4.08s-4.08,1.83-4.08,4.08 c0,1.36,0.66,2.56,1.68,3.3l0.32-0.76c-0.69-0.59-1.12-1.46-1.12-2.43c0-1.78,1.46-3.23,3.24-3.2c1.61,0.02,2.99,1.29,3.14,2.9 c0.08,0.85-0.18,1.64-0.65,2.26L45.35,23.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.23,32.76l-0.2,0.96c-0.03,0.15,0.04,0.31,0.17,0.39c0.06,0.04,0.12,0.05,0.19,0.05 c0.08,0,0.17-0.03,0.23-0.09l0.83-0.69c0.71-0.71,0.76-1.21,0.74-1.77c-0.04-1.98-0.28-7.88-0.74-8.85l-0.29-0.86 c-0.04-0.13-0.15-0.22-0.28-0.24c-0.14-0.02-0.27,0.03-0.35,0.14C44.18,23.62,45.09,31.58,45.23,32.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000085966704107115721140000014668835156042470575_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.76,27.61c-0.4,2.1,0.3,4.36,0.05,6.39c0,0,0-0.02,0.01-0.03c-0.06,0.02-0.34,0.04-0.5,0.01 c-0.28-0.02-0.59-0.13-0.68-0.43c-0.02-0.07-0.09-0.36-0.11-0.45c-0.51-2.2-0.89-4.43-0.88-6.71c-0.55,1.81-0.19,4.32,0.12,6.33 c0.14,0.68,0.19,1.56,0.95,1.84c0.52,0.15,1.15,0.26,1.59-0.11c0.47-0.78,0.11-1.8,0.04-2.64c-0.22-1.39-0.5-2.78-0.52-4.19 C43.83,27.57,43.76,27.57,43.76,27.61L43.76,27.61z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.55,45.39c-1.07,1.65-4.66,1.66-6.32,0.68h0c-0.48-0.33-0.87-0.8-1.02-1.45 c-0.12-0.1-0.03-3.92-0.05-4.2c0.68,1.45,6.87,1.57,7.81,0.01C10.98,41.51,11.29,44.54,10.55,45.39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.72,39.98c-0.58-0.56-2.51-0.88-4.47-0.76c-0.52,0.03-3.09,0.23-3.11,1.21c0,0.16,0.13,0.58,0.4,0.74 c0.95,0.54,3.11,0.98,5.05,0.72c1.38-0.19,2.36-1.06,2.36-1.46C10.95,40.2,10.78,40.04,10.72,39.98z M8.44,41.11 c-0.43,0.04-0.89,0.06-1.37,0.06c-0.98,0-2.28-0.09-2.96-0.34C3.69,40.68,3.6,40.5,3.6,40.39c0.02-0.6,1.54-0.78,2.8-0.84 c0.21,0,0.42-0.01,0.62-0.01c1.16,0,2.61,0.12,3.17,0.46c0.25,0.15,0.3,0.3,0.3,0.41C10.49,40.84,9.38,41.03,8.44,41.11z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.49,37.56c0.76-0.96,1.32-2.09,1.6-3.27c-0.42,1.31-1.16,1.84-1.99,2.72c0,0,0,0.03-0.02,0.07l0.03-1.3 c-0.21-0.7-0.07-1.54,0.5-2.02c0.53-0.45,1.41-0.93,1.72-1.56c0.17,0.35,2.18,2.24,0.54,4.45c-0.78,1.05-1.84,1.03-2.42,0.93 C7.46,37.56,7.48,37.56,7.49,37.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.34,31.95c-0.21-0.68-0.11-1.71-0.52-2.29c0.4,0.02,3.07-0.82,4.22,1.74c0.7,1.57-0.06,2.59-0.27,2.78 c0,0,0,0.01-0.02,0.01c-0.37-0.96-0.92-1.86-1.7-2.7c0.77,0.9,1.03,1.87,1,2.89C5.28,34.47,4.06,34.19,3.34,31.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.51,34.52c0.47,0.43,1.39,0.53,2,0.73c0.65,0.21,1.21,0.83,1.35,1.48c0.15,0.65,0.21,1.04,0.23,1.12 c-0.61-0.95-1.5-1.38-2.43-1.97c1.01,0.75,1.72,1.64,2.24,2.61c-0.48,0.29-1.33,0.6-2.3,0.01C2.43,37.19,3.49,34.87,3.51,34.52z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.78,31.11c2.56,2.4,2.39,5.71,1.97,9.18c-0.01,0.09,0.82,0.19,0.83,0.05c0.11-2.06,0.17-4.44-0.65-6.62 C6.51,32.6,4.88,31.19,4.78,31.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.09,37.94C7.09,37.94,7.09,37.94,7.09,37.94c0,0,0,0-0.01-0.02C7.09,37.93,7.09,37.93,7.09,37.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.93,38.52c0-0.01-0.01-0.02-0.02-0.03c0,0,0.01,0,0.02-0.01l0.01-0.04c0,0.01,0,0.02,0,0.02 C6.93,38.48,6.93,38.5,6.93,38.52z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerScreens);
export default __webpack_public_path__ + "static/media/shower-screens.2c46b5fcbf937f0459f88d90a49953e4.svg";
export { ForwardRef as ReactComponent };